/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
// import Logo from "../../../assets/images/ipoconecta.jpg";
import { useAuth } from "../../../providers/auth";
import { usePartnerData } from "../../../providers/partnerData";
import { useUser } from "../../../providers/user";
import useLoginPopUp from "../Buttons/LoginButton/hooks";

import Toast from "../../../utils/toast";

import LoginButton from "../Buttons/LoginButton";

const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { token, logoutSession } = useAuth();
  const { userData } = useUser();
  const { partnerUrl, partnerData } = usePartnerData();
  const { openLoginPopUp } = useLoginPopUp();

  const [searchParams, setSearchParams] = useSearchParams();

  const scrollDirection = useScrollDirection();

  async function handleToastUnauthorized() {
    await Toast.fire({
      title: "Usuario não Autenticado",
      text: "Faça seu login ou cadastre-se!",
      icon: "warning",
      timer: 10000,
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Cadastrar",
      confirmButtonColor: "#0074D9",
      denyButtonText: "Entrar",
      denyButtonColor: "#198754",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/${partnerUrl}/user`);
      }
      if (result.isDenied) {
        openLoginPopUp();
      }
    });
  }

  function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = useState<null | string>(null);

    useEffect(() => {
      let lastScrollY = window.pageYOffset;

      const updateScrollDirection = () => {
        const scrollY = window.pageYOffset;
        const direction = scrollY > lastScrollY ? "down" : "up";
        if (
          direction !== scrollDirection &&
          (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
        ) {
          setScrollDirection(direction);
        }
        lastScrollY = scrollY > 0 ? scrollY : 0;
      };

      window.addEventListener("scroll", updateScrollDirection);

      return () => {
        window.removeEventListener("scroll", updateScrollDirection);
      };
    }, [scrollDirection]);

    return scrollDirection;
  }

  useEffect(() => {
    if (scrollDirection === "up" || !scrollDirection) {
      document.body.classList.remove("nav-up");
      document.body.classList.add("nav-down");
    } else {
      document.body.classList.remove("nav-down");
      document.body.classList.add("nav-up");
    }
  }, [scrollDirection, pathname]);

  return (
    <header id="header">
      <div className="container">
        <div className="row g-0 py-3 align-content-center align-items-center">
          <div className="col-4 col-md-auto">
            <Link to={`/${partnerUrl}`} id="hlLogo" className="brand-link">
              {partnerData?.imgLogo ? (
                <img
                  id="imgLogo"
                  src={partnerData.imgLogo}
                  alt={partnerData?.nome}
                  className="img-fluid"
                />
              ) : (
                <span className="brand-name">
                  <i className="las la-heartbeat me-2" aria-hidden="true"></i>
                  {partnerData?.nome}
                </span>
              )}
            </Link>
          </div>
          <div className="col-4 col-md text-end">
            <nav id="menu">
              {/* <Dropdown className="d-flex justify-content-end d-md-none">
                <Dropdown.Toggle
                  className="ms-2"
                  variant="btn text-decoration-none btn-outline-light"
                >
                  <i className="las la-fw la-bars me-sm-2 o-50"></i>
                  <span className="d-none d-md-block">Menu</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className="py-2 d-lg-none" as="div">
                    <HashLink
                      className="text-decoration-none text-body"
                      smooth
                      to={`/${partnerUrl}#listagem`}
                    >
                      Listar Profissionais
                    </HashLink>
                  </Dropdown.Item>
                  {!token && (
                    <>
                      <Dropdown.Item className="py-2 px-0">
                        <Link
                          className="btn btn-outline-dark ms-2"
                          to={`/${partnerUrl}/user`}
                        >
                          Cadastrar
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item className="py-2 px-0">
                        <LoginButton theme="green">Entrar</LoginButton>
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown> */}
              <ul className="d-none d-md-block dropdown-list">
                {partnerData?.exibirAgendamento && (
                  <li>
                    <HashLink smooth to={`/${partnerUrl}${searchParams ? '?'+searchParams.toString() : ''}#listagem`} className="rounded-pill">
                      <i className="las la-search me-2"></i>
                      Listar Profissionais
                    </HashLink>
                  </li>
                )}
                {partnerData?.exibirTeleorientacao && (
                  <li>
                    {/* TODO: Adicionar Link para atendimento page && remover toast */}
                    <Link to={`/${partnerUrl}/${token ? 'info' : 'login'}`} className="rounded-pill">
                      <i className="las la-video me-2"></i>
                      Iniciar Atendimento
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>
          <div className="col-4 col-md-auto text-end d-flex justify-content-end">
            {token && (
              <Dropdown>
                <Dropdown.Toggle
                  className="ms-2"
                  variant="btn text-decoration-none btn-outline-light"
                >
                  <i className="las la-fw la-user-circle me-sm-2 o-50"></i>
                  <span className="d-none d-md-block">{userData.name}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <h6 className="d-md-none p-2 mb-0 text-muted small">
                    {userData.name}
                  </h6>
                  <Dropdown.Item
                    className="py-2"
                    active={pathname.includes("/user")}
                    onClick={() => navigate(`/${partnerUrl}/user`)}
                  >
                    <i className="las la-fw la-address-card me-2 o-50"></i>
                    Meus Dados
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="py-2"
                    active={pathname.includes("/consultas")}
                    onClick={() => navigate(`/${partnerUrl}/consultas`)}
                  >
                    <i className="las la-fw la-calendar me-2 o-50"></i>
                    Minhas Consultas
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="py-2"
                    active={pathname.includes("/exames")}
                    onClick={() => navigate(`/${partnerUrl}/exames`)}
                  >
                    <i className="las la-fw la-file-medical-alt me-2 o-50"></i>
                    Meus Exames
                  </Dropdown.Item>
                  <hr className="dropdown-divider" />
                  <Dropdown.Item className="py-2" onClick={logoutSession}>
                    <i className="las la-fw la-sign-out-alt me-2 o-50"></i>
                    Sair
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {!token && (
              <>
                <div className="d-none d-md-block">
                  <Link
                    to={`/${partnerUrl}/user`}
                    className="btn btn-outline-light ms-2"
                  >
                    Cadastrar
                  </Link>
                </div>
                <div className="d-none d-md-block">
                  <LoginButton className="btn-success ms-2">
                    Entrar
                  </LoginButton>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export { Header };
